// extracted by mini-css-extract-plugin
export default {"placeholder":"form-builder-preview_placeholder__jBhiN","previewWrap":"form-builder-preview_previewWrap__WrEgw","previewCardWrap":"form-builder-preview_previewCardWrap__DuEHL"};